import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {

  transform(value: string): string {
      if(value == '00:00am' || value == '00:00pm') return '';
      if(/^0/.test(value)) value = value.replace(/^0/,'');
      return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/time.pipe.ts